import React, { type ReactNode } from 'react';

import { TextLink } from '@garnish/core';

// ─────────────────────────────────────────────────────────────────────────────

export const GiftCardsSubheadingLink = (props: GiftCardsSubheadingLinkProps) => {
  const { children, opensDialog, onPress } = props;

  return (
    <TextLink
      sizeMatch={['14', '18']}
      tabIndex={0} // prevents closing modal from removing it from the tab order.
      role={opensDialog ? 'button' : 'link'}
      accessibilityHasPopup={opensDialog ? 'dialog' : undefined}
      onPress={onPress}
    >
      {children}
    </TextLink>
  );
};

// ─── Types ───────────────────────────────────────────────────────────────────

type GiftCardsSubheadingLinkProps = {
  children: ReactNode;
  opensDialog: boolean;
  onPress: () => void;
};
